import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-request-header',
  templateUrl: './request-header.component.html',
  styleUrls: ['./request-header.component.css']
})
export class RequestHeaderComponent implements OnInit {
 @Input() CompanyName: string;
 @Input() CompanyCR: string;

 @Input() RequestFriendlyName: string;
 @Input() RequestSubmissionDate: Date;
 @Input() RequestStatus: string;
 @Input() comment: string;
 @Input() AirOperatorCertificate: string
//  @Input() IsReasonRequired: boolean = true;


  constructor() { 
  }

  ngOnInit() {
  }

}
